import React from 'react';
import TransportIcon from '../assets/img/transport_icon.svg';
import FoodIcon from '../assets/img/food_icon.svg';
import ProfileBar from '../profiles/Components/ProfileBar';
import NavigateCard from './components/NavigateCard';
import Media from './components/Media';
import {
  faUser,
  faPhoneAlt,
  faBed,
  faExclamationCircle,
  faEnvelope,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/Loader';
import { useTransportDetails } from './queries/actHooks';
import { useUserProfile } from '../profiles/queries/profileHooks';
// import CardOpener from './components/CardOpener';
import { useShowKhelo } from 'utils/HooksUtils';
// import Helmet from 'react-helmet';
import {
  infoUpdateText,
  notAssignedText,
  noTransportAllotedText,
  noTransportInformationText,
} from 'data/noDataText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Transport() {
  const { data: profile } = useUserProfile();
  const { data, isLoading } = useTransportDetails({ user_id: profile.message.sfa_id });

  const isKhelo = useShowKhelo();

  const transport = data;

  return (
    <div>
      {/* <Helmet>
        <title>Food & Internal Transfers/Travel | KIYG Haryana 2021</title>
        <meta
          name="description"
          content="Here's all the information regarding your Food Meals & Internal Transfers (i.e. Travel to/from the Venues) at the #KIYG2021."
        />
        <meta property="og:title" content="Food & Internal Transfers/Travel | KIYG Haryana 2021" />
        <meta
          property="og:description"
          content="Here's all the information regarding your Food Meals & Internal Transfers (i.e. Travel to/from the Venues) at the #KIYG2021."
        />
      </Helmet> */}
      {!isKhelo && <ProfileBar head="Transport" act={true} />}
      <div className="mb-6 max-w-full bg-white flex flex-col gap-6">
        {isLoading ? (
          <Loader />
        ) : !transport ? (
          <div data-cy="transport_empty_msg" className="p-20 text-center text-l font-bold">
            {noTransportAllotedText}
          </div>
        ) : (
          <>
            <div
              className={`bg-white rounded-lg ${
                isKhelo ? 'px-2 md:px-6 shadow py-4' : 'px-6'
              } mt-6 max-w-full bg-white px-6 py-4  font-roboto rounded-lg border border-gray-350`}
            >
              {/* {transport.vehicle_type && transport.vehicle_number && ( */}
              <div className="flex items-center pb-4 border-b border-fade-gray  gap-4">
                <img src={TransportIcon} alt="transport-icon" />
                <div>
                  <p className="text-xs text-deep-gray">Vehicle Type</p>
                  {transport.vehicle_type ? (
                    <>
                      <p data-cy="transport_type" className="text-small font-bold text-dark-gray">
                        {transport.vehicle_type || 'This information will be updated soon.'}
                      </p>
                      {transport.vehicle_number && (
                        <button
                          data-cy="vehicle_number"
                          className="text-xxs blueBadge font-bold mt-1"
                        >
                          {transport.vehicle_number}
                        </button>
                      )}
                      {transport.vehicle_location ? (
                        <div className="mt-2">
                          <a
                            href={transport.vehicle_location}
                            target={'_blank'}
                            rel="noreferrer"
                            className="text-xs cursor-pointer mt-2"
                          >
                            <span>
                              <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                                className="mr-2"
                              ></FontAwesomeIcon>
                              Click to check the location of the vehicle{' '}
                            </span>
                          </a>
                        </div>
                      ) : null}
                    </>
                  ) : (
                    <p className="text-small font-bold text-dark-gray">{notAssignedText}</p>
                  )}
                </div>
              </div>
              {/* )} */}
              <div className="justify-between items-stretch gap-4 md:flex hidden">
                {transport.contact_person_name || transport.contact_person_number ? (
                  <div
                    className={`bg-white rounded-lg ${
                      isKhelo ? 'px-2 md:px-6 shadow py-4' : 'px-6'
                    } mt-6 max-w-full bg-white px-6 py-4  font-roboto rounded-lg w-full border border-gray-350`}
                  >
                    {/* {transport.contact_person_name && ( */}
                    <div className="pb-4 border-b border-fade-gray ">
                      <Media
                        icon={faUser}
                        header={<span className="block ">Contact Person</span>}
                        content={
                          <span className="block ">
                            {transport.contact_person_name || noTransportInformationText}
                          </span>
                        }
                      />
                    </div>
                    {/* )} */}
                    {/* {transport.contact_person_number && ( */}
                    <div className="pt-4 ">
                      <Media
                        icon={faPhoneAlt}
                        header={<span className="block ">Contact</span>}
                        content={
                          <span className="block ">
                            {transport.contact_person_number || noTransportInformationText}
                          </span>
                        }
                      />
                    </div>
                    {/* )} */}
                  </div>
                ) : null}
                {/* <Media
                    icon={faMapMarkerAlt}
                    header="Pickup Point"
                    content={transports.venue}
                  /> */}
                <div
                  className={`bg-white rounded-lg ${
                    isKhelo ? 'px-2 md:px-6 shadow py-4' : 'px-6'
                  } mt-6 max-w-full bg-white px-6 py-4  font-roboto rounded-lg w-full border border-gray-350`}
                >
                  {/* {transport.remarks && ( */}
                  <div className="pb-4 border-b border-fade-gray ">
                    <Media
                      icon={faEnvelope}
                      header={<span className="block ">Remarks</span>}
                      content={
                        <span className="block ">
                          {transport.remarks || (transport.instruction_pdf ? '-' : infoUpdateText)}
                        </span>
                      }
                    ></Media>
                  </div>
                  {/* )} */}
                  {/* {transport.instruction_pdf && ( */}
                  <div className="pt-4">
                    <Media
                      icon={faExclamationCircle}
                      header={<span className="block ">Transport Instructions</span>}
                      content={
                        transport.instruction_pdf ? (
                          <a
                            className="block font-semibold"
                            rel="noreferrer"
                            target="_blank"
                            href={transport.instruction_pdf}
                          >
                            Click for more information
                          </a>
                        ) : (
                          <span>{noTransportInformationText}</span>
                        )
                      }
                    ></Media>
                  </div>
                  {/* )} */}
                </div>
              </div>
              <div className="md:hidden block">
                {transport.contact_person_name && (
                  <div className="pb-4  ">
                    <Media
                      icon={faUser}
                      header={<span className="block ">Contact Person</span>}
                      content={<span className="block ">{transport.contact_person_name}</span>}
                    />
                  </div>
                )}
                {transport.contact_person_number && (
                  <div className="pb-4 border-b border-fade-gray ">
                    <Media
                      icon={faPhoneAlt}
                      header={<span className="block ">Contact</span>}
                      content={<span className="block ">{transport.contact_person_number}</span>}
                    />
                  </div>
                )}
                {/* <Media
                    icon={faMapMarkerAlt}
                    header="Pickup Point"
                    content={transports.venue}
                  /> */}

                <div className="pb-4  ">
                  <Media
                    icon={faEnvelope}
                    header={<span className="block ">Remarks</span>}
                    content={
                      <span className="block ">
                        {transport.remarks ||
                          (transport.instruction_pdf ? '-' : 'Information to be updated shortly.')}
                      </span>
                    }
                  ></Media>
                </div>

                <div className="">
                  <Media
                    icon={faExclamationCircle}
                    header={<span className="block ">Transport Instructions</span>}
                    content={
                      <a
                        className="block font-semibold"
                        rel="noreferrer"
                        target="_blank"
                        href={transport.instruction_pdf}
                      >
                        {!transport.instruction_pdf
                          ? 'This information will be updated soon.'
                          : 'Click to check instructions'}
                      </a>
                    }
                  ></Media>
                </div>
              </div>
              {/* <div className="md:hidden block mt-2">
                <div className="pb-4 ">
                  <Media
                    icon={faEnvelope}
                    header={<span className="block ">Remarks</span>}
                    content={<span className="block ">{transport.remarks || infoUpdateText}</span>}
                  />
                </div>
                <div className="">
                  <Media
                    icon={faExclamationCircle}
                    header={<span className="block ">Instructions</span>}
                    content={
                      <a
                        className="block font-semibold"
                        rel="noreferrer"
                        target="_blank"
                        href={transport.instruction_pdf}
                      >
                        {transport.instruction_pdf ? 'Click to check instructions' : infoUpdateText}
                      </a>
                    }
                  ></Media>
                </div>
              </div> */}
            </div>

            {/* Food */}

            <div
              className={`bg-white rounded-lg ${
                isKhelo ? 'px-2 md:px-6 shadow py-4' : 'px-6'
              } mt-3 max-w-full bg-white px-6 py-4  font-roboto rounded-lg border border-gray-350`}
            >
              <div className="flex items-center gap-4 pb-4 border-b border-fade-gray md:pb-0 md:border-0">
                <img src={FoodIcon} alt="food-icon" />
                <div>
                  <p className="text-small md:text-md font-bold text-dark-gray">{`Food Details`}</p>
                </div>
              </div>
              <div className="justify-between items-stretch gap-4 md:flex hidden">
                <div
                  className={`bg-white rounded-lg ${
                    isKhelo ? 'px-2 md:px-6 shadow pb-4 pt-3' : 'px-6'
                  } mt-5 max-w-full bg-white px-6 pb-4 pt-3 font-roboto rounded-lg w-full border border-gray-350`}
                >
                  <div className="flex justify-between w-full">
                    <div className="border-r-2 border-fade-gray w-1/2">
                      <Media
                        icon={faEnvelope}
                        header={<span className="block ">Remarks</span>}
                        content={
                          <span className="block ">
                            {transport.food_remark ||
                              (transport.food_instruction_pdf ? '-' : infoUpdateText)}
                          </span>
                        }
                      />
                    </div>
                    <div className="w-1/2 flex justify-center">
                      <Media
                        icon={faExclamationCircle}
                        header={<span className="block ">Instructions</span>}
                        content={
                          transport.food_instruction_pdf ? (
                            <a
                              className="block font-semibold"
                              rel="noreferrer"
                              target="_blank"
                              href={transport.food_instruction_pdf}
                            >
                              Click to check instructions
                            </a>
                          ) : (
                            <span>{infoUpdateText}</span>
                          )
                        }
                      ></Media>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden block mt-2">
                <div className="pb-4 ">
                  <Media
                    icon={faEnvelope}
                    header={<span className="block ">Remarks</span>}
                    content={
                      <span className="block ">
                        {transport.food_remark ||
                          (transport.food_instruction_pdf ? '-' : infoUpdateText)}
                      </span>
                    }
                  />
                </div>
                <div className="">
                  <Media
                    icon={faExclamationCircle}
                    header={<span className="block ">Instructions</span>}
                    content={
                      <a
                        className="block font-semibold"
                        rel="noreferrer"
                        target="_blank"
                        href={transport.food_instruction_pdf}
                      >
                        {transport.food_instruction_pdf
                          ? 'Click to check instructions'
                          : infoUpdateText}
                      </a>
                    }
                  ></Media>
                </div>
              </div>
            </div>
          </>
        )}
        {!isKhelo && (
          <NavigateCard
            dataCy="navigate"
            icon={faBed}
            header="Accommodation"
            navigateTo="/act/accommodation"
          />
        )}
      </div>
    </div>
  );
}

export default Transport;
